var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftIcon = function SvgLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 24,
    y: 24,
    fill: "#fff",
    rx: 4,
    transform: "rotate(-180 24 24)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 23.5,
    y: 23.5,
    stroke: "#000",
    strokeOpacity: 0.2,
    rx: 3.5,
    transform: "rotate(-180 23.5 23.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#423DCF",
    d: "M13.925 5.95 15 7.025l-4.95 4.95 4.95 4.95L13.925 18 7.9 11.975z"
  })));
};
export default SvgLeftIcon;